module.exports = __webpack_public_path__ + "img/star-map-hero-sample.cfddba9.png";